import { useEffect, useRef, useState } from "react";

const SHIMMER_WIDTH = 340;
const SHIMMER_HEIGHT = Math.round((SHIMMER_WIDTH * 16) / 9); // 604px

export const InstagramEmbed = ({ url, width = "100%" }) => {
  const ref = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!window.instgrm) {
      const script = document.createElement("script");
      script.src = "//www.instagram.com/embed.js";
      script.async = true;
      script.onload = () => {
        window.instgrm?.Embeds?.process();
        setTimeout(() => setLoading(false), 1500);
      };
      document.body.appendChild(script);
    } else {
      window.instgrm?.Embeds?.process();
      setTimeout(() => setLoading(false), 1500);
    }
  }, [url]);

  return (
    <div style={{ width }} key={url}>
      {loading && (
        <div
          className="shimmer-container"
          style={{
            width: `${SHIMMER_WIDTH}px`,
            height: `${SHIMMER_HEIGHT}px`,
            margin: "0 auto",
          }}
        />
      )}
      <blockquote
        ref={ref}
        className="instagram-media"
        data-instgrm-permalink={url}
        data-instgrm-version="14"
        style={{
          background: "#FFF",
          border: 0,
          borderRadius: "3px",
          boxShadow: "0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)",
          margin: "1px auto",
          maxWidth: "540px",
          minWidth: "326px",
          padding: 0,
          width,
          display: loading ? "none" : "block",
        }}
      />
    </div>
  );
};

export const LinkedInEmbed = ({ url, width = "500", height = "600" }) => {
  const [loading, setLoading] = useState(true);

  return (
    <div style={{ width, margin: "0 auto" }}>
      {loading && (
        <div
          className="shimmer-container"
          style={{
            width: `${SHIMMER_WIDTH}px`,
            height: `${SHIMMER_HEIGHT}px`,
            margin: "0 auto",
          }}
        />
      )}
      <iframe
        src={url}
        height={height}
        width={width}
        frameBorder="0"
        allowFullScreen
        title="LinkedIn Embedded Post"
        style={{
          border: 0,
          margin: "0 auto",
          display: loading ? "none" : "block",
        }}
        onLoad={() => setLoading(false)}
      />
    </div>
  );
};

export const FacebookEmbed = ({ url, width = "500", height = "700" }) => {
  const [loading, setLoading] = useState(true);

  return (
    <div style={{ width, margin: "0 auto" }}>
      {loading && (
        <div
          className="shimmer-container"
          style={{
            width: `${SHIMMER_WIDTH}px`,
            height: `${SHIMMER_HEIGHT}px`,
            margin: "0 auto",
          }}
        />
      )}
      <iframe
        src={url}
        width={width}
        height={height}
        style={{
          border: "none",
          overflow: "hidden",
          display: loading ? "none" : "block",
          margin: "0 auto",
        }}
        scrolling="no"
        frameBorder="0"
        allowFullScreen={true}
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        title="Facebook Embedded Post"
        onLoad={() => setLoading(false)}
      />
    </div>
  );
};

export const TwitterEmbed = ({ url, width = "550" }) => {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadScript = () =>
      new Promise((resolve) => {
        if (window.twttr) return resolve(window.twttr);
        const script = document.createElement("script");
        script.src = "https://platform.twitter.com/widgets.js";
        script.async = true;
        script.onload = () => resolve(window.twttr);
        document.body.appendChild(script);
      });

    const renderTweet = async () => {
      const twttr = await loadScript();
      if (containerRef.current) {
        containerRef.current.innerHTML = ""; // clear previous renders
        const tweetId = url.split("/status/")[1]?.split("?")[0];
        if (tweetId) {
          twttr.widgets
            .createTweet(tweetId, containerRef.current, { width })
            .then(() => setLoading(false));
        }
      }
    };

    renderTweet();
  }, [url, width]);

  return (
    <div style={{ width, margin: "0 auto" }}>
      {loading && (
        <div
          className="shimmer-container"
          style={{ width: "550px", height: "300px", margin: "0 auto" }}
        />
      )}
      <div ref={containerRef} />
    </div>
  );
};